import React from 'react';
import LazyImage from '../LazyImage';
import './HomeServices.css';
import taxImage from '../../assets/images/tax.webp';
import accountingImage from '../../assets/images/accounting.webp';
import tickIcon from '../../assets/icons/tick.png';
import fileIcon from '../../assets/icons/file.png';
import dollarIcon from '../../assets/icons/dollar.png';

const HomeServices = () => {
  return (
    <section className="home-services">
      <div className="home-services-container">
        <div className="home-services-content">
          <div className="home-services-tag">Our Services</div>

          <h2 className="home-services-title">
            Smart, <span className="nowrap">Stress-Free</span> Tax Solutions <br className="desktop-break" />
            <span className="text-primary">Backed by Experts</span>
          </h2>

          <p className="home-services-description">
            Helping Individuals and Businesses Navigate Tax & Accounting — Easily and Accurately.
          </p>

          <div className="home-services-cards">
            <div className="home-service-card">
              <div className="card-content">
                <LazyImage src={taxImage} alt="Tax Services" className="card-image" />

                <h3 className="card-title">Individual Tax Return Services</h3>

                <p className="card-description">
                  Fast, affordable, and compliant tax return services for individuals,
                  sole traders, students, and property investors — with maximum
                  refund and expert ATO checks.
                </p>

                <ul className="card-points">
                  <li>
                    <img src={tickIcon} alt="Check" className="tick-icon" />
                    <span>Online Tax Return Prep & Lodgement</span>
                  </li>
                  <li>
                    <img src={tickIcon} alt="Check" className="tick-icon" />
                    <span>ATO Portal Checks & Data Reconciliation</span>
                  </li>
                  <li>
                    <img src={tickIcon} alt="Check" className="tick-icon" />
                    <span>Expert Deduction Guidance</span>
                  </li>
                  <li>
                    <img src={tickIcon} alt="Check" className="tick-icon" />
                    <span>Crypto, CGT, & Amendment Support</span>
                  </li>
                  <li>
                    <img src={tickIcon} alt="Check" className="tick-icon" />
                    <span>Year-Round Personal Support</span>
                  </li>
                </ul>

                <div className="card-buttons">
                  <button className="btn-primary">
                    <a href="/contact">
                      <img src={fileIcon} alt="File" className="btn-icon" />
                      Start My Return
                    </a>
                  </button>
                  <button className="btn-secondary">
                    <a href="/individual-tax-return">Learn More<span className="visually-hidden"> about individual tax returns</span></a>
                  </button>
                </div>
              </div>
            </div>

            <div className="home-service-card">
              <div className="card-content">
                <LazyImage src={accountingImage} alt="Accounting Services" className="card-image" />

                <h3 className="card-title">Accounting & Business Services</h3>

                <p className="card-description">
                  Bookkeeping, BAS/GST, payroll, and financial advisory for small
                  businesses, freelancers, and startups. Professional support, year-round.
                </p>

                <ul className="card-points">
                  <li>
                    <img src={tickIcon} alt="Check" className="tick-icon" />
                    <span>Bookkeeping & Recordkeeping</span>
                  </li>
                  <li>
                    <img src={tickIcon} alt="Check" className="tick-icon" />
                    <span>BAS & GST Reporting</span>
                  </li>
                  <li>
                    <img src={tickIcon} alt="Check" className="tick-icon" />
                    <span>Payroll Setup & Compliance</span>
                  </li>
                  <li>
                    <img src={tickIcon} alt="Check" className="tick-icon" />
                    <span>Business Structure Advisory</span>
                  </li>
                  <li>
                    <img src={tickIcon} alt="Check" className="tick-icon" />
                    <span>Strategic Tax Planning</span>
                  </li>
                </ul>
                <div className="card-buttons">
                  <button className="btn-primary">
                    <a href="/contact">
                      <img src={dollarIcon} alt="File" className="btn-icon" />
                      Get Accounting Help
                    </a>
                  </button>
                  <button className="btn-secondary">
                    <a href="/accounting-services">Learn More<span className="visually-hidden"> about accounting services</span></a>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeServices;
